var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcHeartFillDetails(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_heart_hider-copy-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.60818752,4.83875 C4.51893753,4.921625 4.43181252,5.0076875 4.34893753,5.098 C2.35356253,7.2495625 2.35356253,10.574125 4.34893753,12.72675 L11.5271875,20.2970625 C11.65575,20.432 11.827875,20.5 12.0010625,20.5 C12.1625625,20.5 12.325125,20.4405 12.4515625,20.3215 L12.476,20.2970625 L19.6510625,12.72675 C21.6464375,10.5751875 21.6464375,7.2495625 19.6510625,5.098 C18.704375,4.0811875 17.3794375,3.502125 15.9896875,3.5 C14.5999375,3.502125 13.2718125,4.080125 12.325125,5.098 L12.0010625,5.4390625 L11.6780625,5.098 C10.693125,4.037625 9.35437502,3.5 8.01243752,3.5 C6.79375002,3.5 5.57187502,3.9430625 4.60818752,4.83875 Z",
    id: "Fill-1",
    stroke: "#FF3939",
    strokeWidth: 0.6,
    fill: "#FF3939",
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcHeartFillDetails);
export default __webpack_public_path__ + "static/media/ic_heart_fill_details.73163089.svg";
export { ForwardRef as ReactComponent };